import moment from 'moment';

interface BoardCurrentDate {
  date: string;
  date_formatted: string;
  timestamp?: number;
  loadedAt?: number;
}

export const withBoardLoadTime = <T extends { boardDetails?: { currentDate?: BoardCurrentDate } }>(
  data: T,
): T => {
  const currentDate = data.boardDetails?.currentDate;
  if (!currentDate) return data;
  return {
    ...data,
    boardDetails: { ...data.boardDetails, currentDate: { ...currentDate, loadedAt: Date.now() } },
  };
};

// The server's profile-local timestamp plus time elapsed since the board loaded keeps a tab
// left open past midnight on the right day without trusting the client clock's absolute value.
export const todayInProfileTimezone = (currentDate: BoardCurrentDate) => {
  const { timestamp, loadedAt } = currentDate;
  if (!timestamp || !loadedAt) {
    return { date: currentDate.date, date_formatted: currentDate.date_formatted };
  }
  // English month names: the server parses these strings with strtotime.
  const profileNow = moment.utc(timestamp * 1000 + (Date.now() - loadedAt)).locale('en');
  return {
    date: profileNow.format('MMM DD ‘YY'),
    date_formatted: profileNow.format('MMM DD,YYYY'),
  };
};
